import onboardingBR from './onboarding.br';
import onboardingMX from './onboarding.mx';
import onboardingCL from './onboarding.cl';
import onboardingCO from './onboarding.co';

const onboarding = {
  BR: onboardingBR,
  MX: onboardingMX,
  CL: onboardingCL,
  CO: onboardingCO,
};

export default onboarding;
